"use strict";
// @ts-ignore
try {
    self['workbox:window:6.5.2'] && _();
}
catch (e) { }
